import React, { useEffect, useState } from "react";
export default function PageLoader(props) {
  return (
    // <>
    //   <div className="d-flex justify-content-center align-items-center  pt-4 pb-4">
    //     <div className="spinner-border" role="status" id="loading">
    //       <span className="visually-hidden">Loading...</span>
    //     </div>
    //   </div>
    // </>
    <div className="vh-90">
      <div className="d-flex justify-content-center align-items-center  pt-4 pb-4 h-100">
        <div className="sk-cube-grid">
          <div className="sk-cube sk-cube1"></div>
          <div className="sk-cube sk-cube2"></div>
          <div className="sk-cube sk-cube3"></div>
          <div className="sk-cube sk-cube4"></div>
          <div className="sk-cube sk-cube5"></div>
          <div className="sk-cube sk-cube6"></div>
          <div className="sk-cube sk-cube7"></div>
          <div className="sk-cube sk-cube8"></div>
          <div className="sk-cube sk-cube9"></div>
        </div>
      </div>
    </div>
  );
}
